<div class="alert w-50 mx-auto my-1 justify-content-center d-print-none">
  @if(waitingMessage) {
    <p class="alert alert-info h2" role="alert" aria-live="assertive">{{waitingMessage}}</p>
  }

  @if(errorMessage) {  
    <p class="alert alert-danger h2" role="alert" aria-live="assertive">{{errorMessage}}</p>
  }
  
  @if(showSpinner) {
    <div class="preloader spinner d-print-none">
      <zbp-preloader></zbp-preloader>
    </div>
  }
</div>

@if(pdfJsSrc) {
  <iframe
    #pdfIframe
    [src]="pdfJsSrc"
    width="100%"
    height="900"
    title="Print Preview">
  </iframe>
}
